import React, { FC } from 'react';
import { ContentCardProps } from './ContentCard';
import { mapContentLinkToCareCardProps } from 'src/modules/dashboard/helpers/contentLinkNodeToCareCard';
import { CareCardPropsWithId, CareCardRow } from 'src/modules/care/components/CareCardRow';

export const CareContentCard: FC<ContentCardProps> = ({ links }) => {
    if (!links) {
        return null;
    }

    const mappedLinks = links
        .map(link => mapContentLinkToCareCardProps(link))
        .filter((link): link is CareCardPropsWithId => link !== null);

    return <CareCardRow cards={mappedLinks} />;
};
